import React from 'react';
import PropTypes from 'prop-types';
import { Toggle, ToggleOption } from '../ui/Toggle'
import {
    ToggleContent,
    ToggleDisplayName,
    TogglePrice
} from './styled';
import RubleLightIcon from '../icons/RubleLightIcon';

const defaultOptionStyle = {
    margin: '0',
    width: '50%',
    textTransform: 'uppercase',
};

const multiOptionStyle = {
    margin: '2.5px',
    width: '48%',
    textTransform: 'uppercase',
    whiteSpace: 'normal',
    lineHeight: '1.75',
    height: 'auto',
    minHeight: '45px',
    paddingTop: '5px',
    paddingBottom: '5px',
};



const contrastOptionStyle = (isMobile) => {
    if (isMobile)
        return {
            margin: '1.5px',
            width: '100%',
            textTransform: 'uppercase',
            paddingLeft: '50px',
            textAlign: 'left',
            height: 'auto',
            padding: '10px 25px 10px 50px',
            lineHeight: 'normal',
        }
    return multiOptionStyle;
};

const ToggleComponent = ({
    input,
    values,
    isMobile,
    showPrice,
    isContrast,
    haveCheckedLabel,
    contrasts,
}) => {

    let checkedlabel;
    if (haveCheckedLabel) {
        checkedlabel = (
            <span className='lazy-image-list__check-label' />
        );
    }

    return (
        <div>
            <Toggle
                className="toggle"
                onChange={(event, value) => {
                    input.onChange(value)
                }}
                onBlur={() => {
                    input.onBlur()
                }}
                block={false}
                equalWidth={false}
                variation={isMobile ? 'centerLight' : 'centerLight'}
                value={input.value}
                size='medium'
                style={isMobile ? { padding: '0 5px' } : null}
            >
                {values.map(({ attrValue, shortName, displayName, price }, i) => (
                    <ToggleOption
                        key={i}
                        value={attrValue}
                        style={isContrast ? contrastOptionStyle(isMobile) : defaultOptionStyle}
                        className='isInline'
                    >

                        {contrasts && contrasts[attrValue] && contrasts[attrValue].article && checkedlabel}
                        <ToggleContent>
                            <ToggleDisplayName>
                                {shortName || displayName}
                            </ToggleDisplayName>
                            {showPrice &&
                                <TogglePrice>
                                    {price}&#160;
                                    <RubleLightIcon size={9} color='currentColor'/>
                                </TogglePrice>}
                        </ToggleContent>
                    </ToggleOption>
                ))}
            </Toggle>
        </div>
    )
}

ToggleComponent.propTypes = {
    input: PropTypes.object.isRequired,
    values: PropTypes.array.isRequired,
    isMobile: PropTypes.bool.isRequired,
    showPrice: PropTypes.bool,
    isContrast: PropTypes.bool,
    haveCheckedLabel: PropTypes.bool,
    contrasts: PropTypes.object,
}

export default ToggleComponent;